import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=1ec5a166&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=js&"
export * from "./EmptyState.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/empty_state.scss?vue&type=style&index=0&id=1ec5a166&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec5a166",
  null
  
)

export default component.exports